"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TicketCard = TicketCard;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/TicketCard/index.tsx
// チケット一覧用カード (Figma: TypeNewDesign2 / TicketCard, h~156px)。
//
// PreSaleCard のボタン無し版。構造:
//   GlassCard (glass=true / cornerRadius radius.sm = 8 / border なし) を外殻に
//   使用。器は同画面のイベント情報カード (EventInfoSection の PropertyBlock)
//   と同じガラス面に揃える — フラットな枠線カードだと同居したときに
//   別の階層のものに見える。
//   コンテンツ (padding 16, gap 8):
//     - MembershipBadge (任意)
//     - Title (14px W600 -0.05px 多行 / JP/Subtitle1)
//     - ステータス行: [Badge 群] + 右寄せ「リセールあり」(14px W600)
//   応募期間セル (任意): bg background.neutral.subtle, height 28px
//
// disabled=true のとき Figma に合わせてカード全体を opacity 0.5 で減光し、
// あわせてタップも受け付けない (申込できない状態 — リセール無しの売り切れ /
// 受付終了。減光しているのに遷移できてしまう状態を作らない)。
//
// href / onClick を渡すとカード全体がタップ領域になる (StoreCard と同じ
// internal/Tappable ラップ)。どちらも無い場合は非インタラクティブな表示専用。
//
// 色はすべて theme.palette.v2 (useV2Palette) と tokens から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Badge_1 = require("../Badge");
var GlassCard_1 = require("../GlassCard");
var Tappable_1 = require("../internal/Tappable");
var MembershipBadge_1 = require("../MembershipBadge");
// ── Component ────────────────────────────────────────────────────
function TicketCard(_a) {
    var memberBadgeLabel = _a.memberBadgeLabel, title = _a.title, _b = _a.statusBadges, statusBadges = _b === void 0 ? [] : _b, resaleLabel = _a.resaleLabel, applicationPeriod = _a.applicationPeriod, _c = _a.disabled, disabled = _c === void 0 ? false : _c, href = _a.href, onClick = _a.onClick;
    var p = (0, theme_1.useV2Palette)();
    return (
    // disabled のときは減光だけでなくタップ領域そのものを外す
    (0, jsx_runtime_1.jsx)(Tappable_1.Tappable, { href: disabled ? undefined : href, onClick: disabled ? undefined : onClick, 
        // CARD_TAPPABLE_SX の角丸はカード標準の 12px。このカードは 8px なので
        // 上書きする (ripple がカードの角からはみ出さないように)
        sx: __assign(__assign({}, Tappable_1.CARD_TAPPABLE_SX), { borderRadius: "".concat(tokens_1.radius.sm, "px") }), children: (0, jsx_runtime_1.jsxs)(GlassCard_1.GlassCard, { cornerRadius: tokens_1.radius.sm, bordered: false, sx: disabled ? { opacity: 0.5 } : undefined, children: [(0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: "".concat(tokens_1.spacing.sm, "px"), sx: { p: "".concat(tokens_1.spacing.md, "px") }, children: [memberBadgeLabel && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: { alignSelf: 'flex-start' }, children: (0, jsx_runtime_1.jsx)(MembershipBadge_1.MembershipBadge, { label: memberBadgeLabel }) })), (0, jsx_runtime_1.jsxs)(material_1.Stack, { spacing: "".concat(tokens_1.spacing.sm, "px"), sx: { width: '100%' }, children: [(0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                        width: '100%',
                                        fontSize: 14,
                                        fontWeight: tokens_1.fontWeight.semiBold,
                                        lineHeight: '20px',
                                        letterSpacing: '-0.05px',
                                        color: p.foreground.neutral.primary,
                                    }, children: title }), (statusBadges.length > 0 || !!resaleLabel) && ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "center", spacing: "".concat(tokens_1.spacing.xs, "px"), sx: { minHeight: 20, width: '100%' }, children: [statusBadges.map(function (badge, i) { return ((0, jsx_runtime_1.jsx)(Badge_1.Badge, { label: badge.label, variant: badge.variant, color: badge.color, endIcon: badge.endIcon }, i)); }), resaleLabel && ((0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                                                flex: 1,
                                                textAlign: 'right',
                                                fontSize: 14,
                                                fontWeight: tokens_1.fontWeight.semiBold,
                                                color: p.foreground.semantic.info,
                                                whiteSpace: 'nowrap',
                                            }, children: resaleLabel }))] }))] })] }), applicationPeriod && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                        height: 28,
                        backgroundColor: p.background.neutral.subtle,
                        px: "".concat(tokens_1.spacing.md, "px"),
                        display: 'flex',
                        alignItems: 'center',
                    }, children: (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: {
                            fontSize: 10,
                            fontWeight: tokens_1.fontWeight.regular,
                            lineHeight: '12px',
                            color: p.foreground.neutral.primary,
                        }, children: applicationPeriod }) }))] }) }));
}
